var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from "react";
import { nanoid } from "nanoid";
import RadioButton from "../RadioButton";
import Label from "../Label";
import style from "./style.module.scss";
export default function StyledRadioButton(props) {
    const { name, value, label, description } = props, inputProps = __rest(props, ["name", "value", "label", "description"]);
    const radioID = nanoid(10);
    const descriptionID = nanoid(10);
    return (_jsxs("div", { className: style["styled-radio-button"], children: [_createElement(RadioButton, Object.assign({ id: radioID, "aria-describedby": descriptionID, name: name, value: value }, inputProps, { key: radioID })), _jsxs("div", { className: style["styled-radio-button__details"], children: [label ? (_jsx(Label, { htmlFor: radioID, className: style["styled-radio-button__details__label"], children: label })) : null, description ? (_jsx("div", { className: style["styled-radio-button__details__description"], id: descriptionID, children: description })) : null] })] }));
}
